export default "__VITE_ASSET__c00e1254__"